export default __webpack_public_path__ + "static/media/what.3f45bf60.png";